// extracted by css-extract-rspack-plugin
export default {"IconButton":"add-column-header-module__IconButton__CJ66R92","DisabledButton":"add-column-header-module__DisabledButton__Bd7xqTy"};